import gql from 'graphql-tag';

export default gql`
  fragment taskStepFragment on TaskStep {
    id
  }
`;
